module.exports = __webpack_public_path__ + "static/cake-3228a1387958d765d56b29c024d351f7.jpg";